<template>
  <div class="base-logo-s">
    <a class="base-logo-s__link jt-logo" :href="href" :title="title">
      <img src="./logo-kb.png" srcset="./logo-kb-2x.png 2x, ./logo-kb-3x.png 3x" class="base-logo-s__logo" :alt="alt">
      <img src="./powered-by-vox-de.png" srcset="./powered-by-vox-de-2x.png 2x, ./powered-by-vox-de-3x.png 3x" class="base-logo-s__powered_by" alt="powered by VOX.de">
    </a>
  </div>
</template>

<script>
export default {
    name: "kb-base-logo-s",
    props: {
        "href": "",
        "title": "",
        "alt": "",
    }
}
</script>

<style lang="scss" scoped>

.base-logo-s {

    display:inline-block;

    &__link {
        border: 0;
        text-decoration: none;
        display: block;
        height: 100%;
    }

    &__logo {
        border: 0;
        width: 109px;
        height: 32px;
    }

    &__powered_by {
      margin-left: 3px;
      margin-bottom: 5px;
      vertical-align: bottom;
    }
}

</style>
